import type { LiveShift } from '../api/generated/LiveShift'

export type LiveCount = {
  label: string
  color: 'success' | 'info' | 'warning' | 'error' | 'default'
}

const plural = (n: number, one: string, many: string) => `${n} ${n > 1 ? many : one}`

/** The non-zero volunteer counts of a live shift, from present to missing. */
export function liveCounts(shift: LiveShift): LiveCount[] {
  const counts: [number, LiveCount][] = [
    [shift.checked_in, { label: `${shift.checked_in} en poste`, color: 'success' }],
    [shift.confirmed, { label: plural(shift.confirmed, 'confirmé', 'confirmés'), color: 'info' }],
    [
      shift.unconfirmed,
      { label: plural(shift.unconfirmed, 'non confirmé', 'non confirmés'), color: 'warning' },
    ],
    [
      shift.unfilled,
      { label: plural(shift.unfilled, 'place non prise', 'places non prises'), color: 'error' },
    ],
    [
      shift.offered,
      { label: plural(shift.offered, 'demande en cours', 'demandes en cours'), color: 'default' },
    ],
  ]
  return counts.filter(([n]) => n > 0).map(([, count]) => count)
}

/** `Il manque 2 bénévoles`: required volunteers neither at their position nor confirmed. */
export function missingMessage(shift: LiveShift): string {
  const missing = Math.max(shift.required_volunteers - shift.checked_in - shift.confirmed, 0)
  return `Il manque ${plural(missing, 'bénévole', 'bénévoles')}`
}
